import type {OpenExpedientCustomerOfferFormPayload} from "./open-expedient-customer-offer.schema";
import {OpenExpedientCustomerOfferBody} from "@project/sdk/sales/zod";
import {openExpedientCustomerOffer} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientMutationKeys} from "../../../expedient-keys";

export function openExpedientCustomerOfferMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.openExpedientCustomerOffer,
    mutationFn: (payload: OpenExpedientCustomerOfferFormPayload) =>
      openExpedientCustomerOffer(id, OpenExpedientCustomerOfferBody.parse(payload)),
  });
}
